<template>
  <app-page-wrapper-grid class="change-password__wrapper">
    <form class="change-password m-l-30 m-r-30 m-t-100 m-b-20">
      <h2 class="m-b-20">Change Password</h2>
      <template v-if="isFormSubmitted">
        <app-notifier v-for="(message, index) in errors" :key="index" type="failed" :data="message" />
      </template>
      <div class="change-password__section p-t-20 p-b-20 p-l-20 p-r-20">
        <app-input
          v-model="v$.newPassword.$model"
          label="New Password"
          type="password"
          :has-error="v$.newPassword.$error && isFormSubmitted"
          class="new-password m-t-10"
        />
        <app-input
          v-model="v$.confirmNew.$model"
          label="Confirm New Password"
          type="password"
          :has-error="v$.confirmNew.$error && isFormSubmitted"
          class="confirm-password m-t-10"
        />
        <app-button
          text="update password"
          :aria-label="'update password'"
          :handler="submit"
          class="change-password__button m-t-20"
        />
      </div>
      <div class="change-password__footer m-t-10">
        <app-link :route-to="{ name: ROUTE_NAMES.USER_PROFILE }" class="m-t-10">&lt; Back to Account</app-link>
      </div>
    </form>
  </app-page-wrapper-grid>
</template>

<script>
import { mapActions } from "vuex";
import useVuelidate from "@vuelidate/core";
import { showToaster, passwordValidations, ROUTE_NAMES } from "../../../../utils";

export default {
  setup: () => ({ v$: useVuelidate() }),
  name: "ChangePassword",
  data() {
    return {
      isFormSubmitted: false,
      newPassword: "",
      confirmNew: "",
      errors: [],
      validatorsCollection: [],
      ROUTE_NAMES
    };
  },
  validations: {
    newPassword: passwordValidations(),
    confirmNew: passwordValidations()
  },
  methods: {
    ...mapActions({
      updateUserInfo: "user/updateUserInfo"
    }),
    submit() {
      this.isFormSubmitted = false;
      this.errors.length = 0;

      this.v$.$touch();
      // TODO: move such validation functions to a separate validation comp/store
      this.checkIncompleteFields();
      this.checkInvalidFields();

      if (!this.v$.$invalid) {
        return this.updateUserInfo([
          {
            path: "password",
            value: this.newPassword
          }
        ])
          .then(() => {
            showToaster.call(this, {
              title: "Success",
              errorMessage: "Password has been updated"
            });
            return this.$router.push({ name: ROUTE_NAMES.USER_PROFILE });
          })
          .catch(reject => {
            return this.errors.push(reject.data.message || reject.data.error);
          });
      }
      this.isFormSubmitted = true;
    },
    checkIncompleteFields() {
      const emptyFieldsExist = this.validatorsCollection.some(item => item.validator.required?.$invalid || false);

      if (emptyFieldsExist) {
        this.errors.push("Incomplete fields");
      }
    },
    checkInvalidFields() {
      this.validatorsCollection.forEach(item => {
        if (item.validator.$invalid && item.errorMessage) {
          this.errors.push(item.errorMessage);
        }
      });
    }
  },
  mounted() {
    this.validatorsCollection = [
      {
        validator: this.v$.newPassword,
        errorMessage: "New password must be at least 6-symbol length"
      },
      {
        validator: this.v$.confirmNew,
        errorMessage: "Passwords must be identical"
      }
    ];
  }
};
</script>

<style scoped lang="scss">
.dark {
  .change-password__section {
    background-color: $background-dark--2;
  }
}

.link {
  outline: none;
  color: $secondary-color;
  border: none;
  background: transparent;

  &:hover {
    text-decoration: underline;
  }
}

.change-password {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 620px;
  height: 100%;

  &__wrapper {
    display: flex;
    align-items: center;
  }

  &__footer {
    width: 100%;
    text-align: left;
  }

  &__section {
    background-color: $item-hover;
    border-radius: 5px;
    width: 100%;
  }

  &__button {
    height: 40px;
  }

  @include respond-to-mobile {
    width: 100%;
    margin-top: 40px;
  }
}
</style>
